import MultipleQuestions from "./MultipleQuestions";

export default MultipleQuestions;
